import { IJobCollaboarationPermission, UserModule } from '@/store/modules/user'
import { checkPermissionMatching } from '@/store/modules/permission'

export const hasJobLevelPermission = (permissions: string[], jobRoleId: string): boolean => {
  const userPermissions: string[] = UserModule.permissionV1
  let hasPermission: boolean = permissions.reduce((previousValue: boolean, permission: string) => {
    return previousValue || checkPermissionMatching(userPermissions, permission)
  }, false)

  if (!hasPermission) {
    const collaboratorPermissions: IJobCollaboarationPermission[] = UserModule.jobCollaborationPermissionsV1
    const jobPermission: IJobCollaboarationPermission | undefined = collaboratorPermissions.find((each) => each.jobRoleId === jobRoleId)
    if (jobPermission) {
      hasPermission = permissions.reduce((previousValue: boolean, permission: string) => {
        return previousValue || checkPermissionMatching(jobPermission.permissions, permission)
      }, false)
    }
  }

  return hasPermission
}
